var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "font-size": "0.14rem" } },
    [
      _c("popup", { attrs: { title: "腾讯充值隐私政策", show: _vm.isShow } }, [
        _c(
          "div",
          { staticClass: "policy-popup" },
          [
            _vm._l(_vm.privacyPolicy, function (item, index) {
              return _c("p", { key: index }, [_vm._v(_vm._s(item))])
            }),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        详细信息请点击\n        "),
              _c(
                "a",
                { attrs: { href: "https://pay.qq.com/h5/store/privacy.html" } },
                [_vm._v("《用户协议》")]
              ),
              _vm._v("\n        与\n        "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://pay.qq.com/h5/store/privacy-policy.html",
                  },
                },
                [_vm._v("《隐私协议》")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn popup-button-primary",
                on: { click: _vm.handleConfirm },
              },
              [_vm._v("同意")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn popup-button-default",
                on: { click: _vm.handleCancel },
              },
              [_vm._v("拒绝")]
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }